// NPM MODULES
import React from 'react';
import { Typography } from '@mui/material';
import HelpTooltip from '../HelpTooltip';

const MessagePartTooltip = () => {
  return (
    <HelpTooltip
      message={
        <>
          <Typography fontSize={12} gutterBottom>
            Messages = Quantity of sends to recipients
          </Typography>
          <Typography fontSize={12}>
            Parts = Quantity of SMS sent per message
          </Typography>
          <Typography fontSize={12}>
            160 characters = 1 part or 1 SMS, any message exceeding 160
            characters is broken into parts made up of 153 characters — Unicode
            messages are broken into 70 and 67 respectively. All messages have a
            limit of 5 parts
          </Typography>
        </>
      }
    />
  );
};

export default MessagePartTooltip;
